module.exports = __webpack_public_path__ + "menu.png?4252276542d1a91f3af4073e7dce273a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu.png
// module id = 7
// module chunks = 0